import React, { useState } from "react";
import { Link } from "react-router-dom";
import LayoutAuth from "./Layout";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";

export function PageId19(props) {
	console.log("PageId19", props);
	const [loading, setLoading] = useState(false);

	const enableLoading = () => {
		setLoading(true);
	};

	const disableLoading = () => {
		setLoading(false);
	};

	return (
		<LayoutAuth>
			<div>
				<h1>회원 가입이 완료 되었습니다.</h1>
				<div className="form-group d-flex flex-wrap flex-center mt-10">
					<Link to="/auth/login">
						<button
							id="join-success"
							type="submit"
							className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
						>
							<span>로그인 하기</span>
							{loading && <span className="ml-3 spinner spinner-white"></span>}
						</button>
					</Link>
				</div>
			</div>
		</LayoutAuth>
	);
}

// export default PageId19;
export default injectIntl(connect(null, auth.actions)(PageId19));
